import { doRequest } from '@r1-frontend/do-request/index';
import { getRegionsGroups } from '@r1-frontend/api-domru/api-content/v1/geography/get-regions';
import { IRegionsWithCitiesGroup } from '@r1-frontend/api-domru/api-content/v1/geography/get-regions/dto/ResponseDto';

import { setRegions } from '~/src/components/CitySelectContainer/store/actionCreators';
import { TAppThunkDispatch, TGetState } from '~/src/store';
import selectProviderId from '~/src/store/selectors/selectProviderId';

const fetchRegionsList = () => {
    return async(dispatch: TAppThunkDispatch, getState: TGetState): Promise<void> => {
        const state = getState();
        const providerId = selectProviderId(state);

        const resp = await doRequest.apiContent<IRegionsWithCitiesGroup>(
            getRegionsGroups(providerId, { sortBy: 'name', groupBy: 'firstChar' }),
        );

        if (resp.isSuccess) {
            dispatch(setRegions(resp.payload));
        }
    };
};

export default fetchRegionsList;
